import React from 'react';
import PropTypes from 'prop-types';

// Иконки из новой верстки (inline SVG, stroke=currentColor).
// Единый враппер — без копипасты, рисуем только содержимое каждой иконки.

const SvgIcon = ({ strokeWidth = 1.8, children }) => (
    <svg
        viewBox="0 0 24 24"
        width="20"
        height="20"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        {children}
    </svg>
);

SvgIcon.propTypes = {
    strokeWidth: PropTypes.number,
    children: PropTypes.node.isRequired
};

const GEAR_PATH = 'M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z';

export const SettingsIcon = () => (
    <SvgIcon strokeWidth={1.7}>
        <circle cx="12" cy="12" r="3" />
        <path d={GEAR_PATH} />
    </SvgIcon>
);

export const TeamsIcon = () => (
    <SvgIcon>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </SvgIcon>
);

export const EventsIcon = () => (
    <SvgIcon>
        <rect x="3" y="4" width="18" height="18" rx="2" />
        <path d="M16 2v4M8 2v4M3 10h18" />
    </SvgIcon>
);

export const GamesIcon = () => (
    <SvgIcon>
        <path d="M6 11h4M8 9v4M15 12h.01M18 10h.01" />
        <rect x="2" y="6" width="20" height="12" rx="4" />
    </SvgIcon>
);

export const BroadcastIcon = () => (
    <SvgIcon>
        <path d="m3 11 18-5v12L3 14v-3zM11.6 16.8a3 3 0 1 1-5.8-1.6" />
    </SvgIcon>
);

export const OrgIcon = () => (
    <SvgIcon>
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 11l-3 3-2-2" />
    </SvgIcon>
);

export const CampIcon = () => (
    <SvgIcon>
        <circle cx="12" cy="12" r="3" />
        <path d={GEAR_PATH} />
    </SvgIcon>
);

export const GlobeIcon = () => (
    <SvgIcon>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />
    </SvgIcon>
);

export const ChevronDownIcon = () => (
    <SvgIcon strokeWidth={2}>
        <path d="M6 9l6 6 6-6" />
    </SvgIcon>
);

export const BellIcon = () => (
    <SvgIcon>
        <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0" />
    </SvgIcon>
);

export const MenuIcon = () => (
    <SvgIcon strokeWidth={2}>
        <path d="M3 6h18M3 12h18M3 18h18" />
    </SvgIcon>
);

export const PlusIcon = () => (
    <SvgIcon strokeWidth={2}>
        <path d="M12 5v14M5 12h14" />
    </SvgIcon>
);

export const CloseIcon = () => (
    <SvgIcon strokeWidth={2}>
        <path d="M18 6 6 18M6 6l12 12" />
    </SvgIcon>
);

export const CopyIcon = () => (
    <SvgIcon>
        <rect x="9" y="9" width="13" height="13" rx="2" />
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
    </SvgIcon>
);

export const InfoIcon = () => (
    <SvgIcon>
        <circle cx="12" cy="12" r="10" />
        <path d="M12 16v-4M12 8h.01" />
    </SvgIcon>
);

// ——— иконки игр (карточки тумблеров «Игры смены») ———
export const NeighborIcon = () => (
    <SvgIcon>
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    </SvgIcon>
);

export const FairIcon = () => (
    <SvgIcon>
        <path d="M3 9l1-5h16l1 5M4 9h16v11H4zM9 9v11" />
    </SvgIcon>
);

export const KillerIcon = () => (
    <SvgIcon>
        <circle cx="12" cy="12" r="9" />
        <circle cx="12" cy="12" r="3" />
        <path d="M12 1v4M12 19v4M1 12h4M19 12h4" />
    </SvgIcon>
);

export const DozorIcon = () => (
    <SvgIcon>
        <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </SvgIcon>
);

export const LegendIcon = () => (
    <SvgIcon>
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2zM22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
    </SvgIcon>
);

export const DemocracyIcon = () => (
    <SvgIcon>
        <path d="M3 21h18M6 21V10M18 21V10M4 10l8-6 8 6" />
    </SvgIcon>
);

export const BetIcon = () => (
    <SvgIcon>
        <path d="M3 17l6-6 4 4 8-8M21 7h-4M21 7v4" />
    </SvgIcon>
);

export const TeamTaskIcon = () => (
    <SvgIcon>
        <path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2" />
        <rect x="9" y="3" width="6" height="4" rx="1" />
        <path d="m9 13 2 2 4-4" />
    </SvgIcon>
);

export const SendIcon = () => (
    <SvgIcon>
        <path d="m22 2-7 20-4-9-9-4z" />
        <path d="M22 2 11 13" />
    </SvgIcon>
);

export const PersonIcon = () => (
    <SvgIcon>
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
    </SvgIcon>
);

export const PaperclipIcon = () => (
    <SvgIcon>
        <path d="m21.4 11.05-8.49 8.49a5 5 0 0 1-7.07-7.07l8.49-8.49a3 3 0 0 1 4.24 4.24l-8.49 8.49a1 1 0 0 1-1.41-1.41l7.78-7.78" />
    </SvgIcon>
);

export const FileIcon = () => (
    <SvgIcon>
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <path d="M14 2v6h6" />
    </SvgIcon>
);

export const EditPencilIcon = () => (
    <SvgIcon>
        <path d="M12 20h9" />
        <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </SvgIcon>
);

export const DragDotsIcon = () => (
    <svg viewBox="0 0 16 16" fill="currentColor">
        <circle cx="5" cy="3" r="1.4" /><circle cx="11" cy="3" r="1.4" />
        <circle cx="5" cy="8" r="1.4" /><circle cx="11" cy="8" r="1.4" />
        <circle cx="5" cy="13" r="1.4" /><circle cx="11" cy="13" r="1.4" />
    </svg>
);

export const ImageIcon = () => (
    <SvgIcon>
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <circle cx="9" cy="9" r="2" />
        <path d="m21 15-5-5L5 21" />
    </SvgIcon>
);

export const MusicIcon = () => (
    <SvgIcon>
        <path d="M9 18V5l12-2v13" />
        <circle cx="6" cy="18" r="3" />
        <circle cx="18" cy="16" r="3" />
    </SvgIcon>
);

export const FilmIcon = () => (
    <SvgIcon>
        <rect x="2" y="3" width="20" height="18" rx="2" />
        <path d="M7 3v18M17 3v18M2 9h5M2 15h5M17 9h5M17 15h5" />
    </SvgIcon>
);

export const DownloadIcon = () => (
    <SvgIcon>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3" />
    </SvgIcon>
);

export const ClockIcon = () => (
    <SvgIcon>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
    </SvgIcon>
);

export const TrashIcon = () => (
    <SvgIcon>
        <path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" />
    </SvgIcon>
);

export const LockIcon = () => (
    <SvgIcon>
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </SvgIcon>
);

export const HomeIcon = () => (
    <SvgIcon>
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </SvgIcon>
);

export const MapIcon = () => (
    <SvgIcon>
        <path d="M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2zM9 4v14M15 6v14" />
    </SvgIcon>
);

export const TrophyIcon = () => (
    <SvgIcon>
        <path d="M6 9a6 6 0 0 0 12 0M8 21h8M12 15v6M8 3h8v6a4 4 0 0 1-8 0z" />
    </SvgIcon>
);

// Залитая иконка пользователя (аватары участников/игрока).
export const PersonFillIcon = () => (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
        <circle cx="12" cy="9" r="4" />
        <path d="M4 22c0-4.4 3.6-8 8-8s8 3.6 8 8z" />
    </svg>
);

export const RefreshIcon = () => (
    <SvgIcon>
        <path d="M23 4v6h-6M1 20v-6h6" />
        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </SvgIcon>
);

export const CheckIcon = () => (
    <SvgIcon strokeWidth={2.4}>
        <path d="M20 6 9 17l-5-5" />
    </SvgIcon>
);

export const HourglassIcon = () => (
    <SvgIcon>
        <path d="M5 22h14M5 2h14M17 22v-4.17a2 2 0 0 0-.59-1.42L12 12l-4.41 4.41A2 2 0 0 0 7 17.83V22M7 2v4.17a2 2 0 0 0 .59 1.42L12 12l4.41-4.41A2 2 0 0 0 17 6.17V2" />
    </SvgIcon>
);

export const CircleIcon = () => (
    <SvgIcon>
        <circle cx="12" cy="12" r="9" />
    </SvgIcon>
);

export const ShopIcon = () => (
    <SvgIcon>
        <path d="M3 9l1.5-5h15L21 9M4 9v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9M3 9h18M9 20v-6h6v6" />
    </SvgIcon>
);

export const FolderIcon = () => (
    <SvgIcon>
        <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    </SvgIcon>
);

export const FootballIcon = () => (
    <SvgIcon strokeWidth={1.6}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7.4l3.3 2.4-1.25 3.9H9.95L8.7 9.8z" />
        <path d="M12 3v4.4M20.5 9.8l-4.2 3M18.05 18.2l-4-3.5M5.95 18.2l4-3.5M3.5 9.8l4.2 3" />
    </SvgIcon>
);

export const VolleyballIcon = () => (
    <SvgIcon strokeWidth={1.6}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 3a15 15 0 0 0-3.2 17.5M12 3a15 15 0 0 1 9 8.6M20.5 14A15 15 0 0 1 4 16.5" />
    </SvgIcon>
);

// Монета SOL (залитая, из верстки). Используется в ставках/балансах/стоимостях.
export const CoinIcon = () => (
    <svg viewBox="0 0 512 512" width="20" height="20" fill="currentColor">
        <g transform="translate(0,512) scale(0.1,-0.1)" stroke="none">
            <path d="M2380 5113 c-360 -25 -741 -136 -1042 -304 -720 -402 -1190 -1082 -1314 -1904 -24 -161 -25 -528 -1 -700 58 -421 228 -830 490 -1180 100 -134 308 -350 439 -455 353 -285 787 -477 1223 -541 970 -142 1921 264 2482 1061 273 389 420 810 455 1307 31 453 -52 870 -258 1283 -143 286 -274 471 -489 685 -187 188 -352 312 -580 439 -426 236 -916 344 -1405 309z m509 -339 c387 -58 765 -223 1062 -462 145 -117 331 -314 443 -470 68 -94 184 -301 230 -411 60 -141 111 -313 142 -480 35 -182 44 -485 20 -670 -99 -747 -559 -1392 -1229 -1721 -332 -163 -630 -233 -992 -234 -467 -2 -873 122 -1270 387 -132 88 -215 159 -350 298 -337 348 -545 778 -611 1269 -21 156 -18 427 6 589 42 286 129 543 264 780 371 649 1007 1065 1741 1141 122 12 416 4 544 -16z" />
            <path d="M2350 4443 c-86 -11 -289 -56 -378 -84 -257 -81 -647 -324 -707 -440 -50 -97 30 -229 138 -229 52 0 83 15 146 69 201 174 486 304 766 352 226 37 496 17 725 -56 213 -68 427 -196 597 -356 51 -48 82 -70 108 -75 138 -25 243 95 192 219 -23 54 -246 240 -407 340 -168 103 -405 195 -616 238 -88 18 -149 22 -319 24 -115 2 -226 1 -245 -2z" />
            <path d="M1269 3447 c-24 -16 -38 -36 -49 -70 -14 -45 -17 -47 -52 -47 -52 0 -150 -33 -208 -70 -161 -103 -244 -316 -195 -503 41 -157 140 -268 292 -325 63 -23 84 -26 298 -31 199 -5 235 -8 258 -24 92 -60 88 -206 -6 -250 -29 -14 -70 -17 -246 -17 l-211 0 -36 33 c-27 24 -38 45 -45 82 -18 96 -69 138 -162 132 -61 -4 -95 -22 -131 -71 -34 -45 -29 -143 11 -229 70 -147 207 -244 364 -256 81 -6 83 -7 90 -35 9 -34 43 -72 81 -92 67 -35 167 0 203 71 11 22 20 41 20 42 0 1 32 7 70 13 228 36 395 230 395 459 0 109 -71 256 -162 336 -108 95 -223 125 -483 125 -196 0 -227 7 -265 60 -52 73 -31 173 46 218 37 21 47 22 241 20 250 -4 251 -4 298 -141 53 -152 281 -134 310 25 12 63 -34 190 -98 272 -58 73 -218 156 -301 156 -41 0 -49 7 -67 55 -23 61 -66 85 -154 85 -58 0 -79 -4 -106 -23z" />
            <path d="M2553 3310 c-107 -22 -240 -101 -305 -183 -57 -72 -105 -180 -119 -267 -7 -47 -9 -168 -7 -339 5 -239 7 -272 26 -324 103 -281 341 -441 595 -399 165 28 318 145 397 304 22 46 45 107 50 137 16 87 12 573 -5 656 -42 201 -200 363 -397 410 -68 16 -168 18 -235 5z m220 -342 c22 -13 55 -43 72 -66 l30 -44 0 -291 c0 -323 0 -320 -67 -385 -41 -41 -123 -66 -179 -57 -58 10 -129 62 -156 115 -24 44 -24 47 -21 331 l3 286 27 41 c65 97 188 127 291 70z" />
            <path d="M3490 3297 c-19 -12 -43 -38 -54 -57 -20 -34 -21 -50 -24 -655 -3 -684 -4 -677 59 -729 52 -44 88 -47 447 -44 307 3 340 5 367 21 104 63 101 209 -5 271 -32 19 -54 21 -287 24 l-252 3 -3 532 c-3 517 -4 533 -24 572 -41 79 -153 110 -224 62z" />
            <path d="M3733 1487 c-18 -6 -72 -46 -121 -88 -295 -257 -620 -391 -983 -406 -297 -12 -571 52 -823 193 -90 50 -141 86 -295 203 -46 36 -60 41 -105 41 -94 0 -156 -61 -156 -155 0 -65 21 -99 107 -171 247 -206 553 -348 887 -411 70 -13 145 -17 321 -17 213 0 240 2 358 27 342 73 611 206 878 434 146 125 172 177 130 269 -32 71 -125 109 -198 81z" />
        </g>
    </svg>
);
